import type { SVGProps } from 'react'

import { CustomIconProps } from '@/shared/ui/icon-template'

export const SberBankLogo = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="164" height="27" viewBox="0 0 164 27" fill="none" {...props}>
			<g clipPath="url(#clip0_21889_17616)">
				<path
					d="M73.1471 7.79376L76.5572 5.25391H65.1406V20.4682H76.5572V17.9283H68.4025V14.0438H75.3711V11.504H68.4025V7.79376H73.1471Z"
					fill="#21A038"
				/>
				<path
					d="M56.5125 11.1802H52.5588V7.79376H58.8849L62.295 5.25391H49.2969V20.4682H56.0925C59.898 20.4682 62.0973 18.7252 62.0973 15.6873C62.0973 12.7739 60.1204 11.1802 56.5125 11.1802ZM55.9689 17.9283H52.5588V13.7201H55.9689C58.0447 13.7201 59.0085 14.4173 59.0085 15.8367C59.0085 17.256 57.9705 17.9283 55.9689 17.9283Z"
					fill="#21A038"
				/>
				<path
					d="M85.7961 5.25391H79.5938V20.4682H82.8555V16.1603H85.8209C89.7747 16.1603 92.2458 14.0687 92.2458 10.7071C92.2458 7.34555 89.7747 5.25391 85.7961 5.25391ZM85.7221 13.6205H82.8309V7.79376H85.7221C87.8226 7.79376 88.9593 8.83959 88.9593 10.7071C88.9593 12.5747 87.8226 13.6205 85.7221 13.6205Z"
					fill="#21A038"
				/>
				<path
					d="M43.716 17.1812C42.8512 17.6544 41.8874 17.9034 40.8989 17.9034C37.9583 17.9034 35.8331 15.7869 35.8331 12.8735C35.8331 9.96011 37.9583 7.84356 40.8989 7.84356C41.9614 7.81866 42.9993 8.16726 43.8643 8.78979L46.2119 7.04673L46.0635 6.89733C44.7045 5.6772 42.8758 5.05469 40.8001 5.05469C38.5513 5.05469 36.5003 5.8266 35.0177 7.22104C33.5349 8.66529 32.6947 10.6822 32.7443 12.7739C32.7195 14.8904 33.5349 16.9324 35.0177 18.4262C36.5745 19.8955 38.6501 20.7171 40.7753 20.6674C43.1229 20.6674 45.174 19.8457 46.5578 18.3516L44.4573 16.7829L43.716 17.1812Z"
					fill="#21A038"
				/>
				<path
					d="M131.463 5.27881V20.493H134.725V14.2679H141.668V20.493H144.93V5.27881H141.668V11.5289H134.725V5.27881H131.463ZM125.853 20.493H129.288L122.913 5.27881H119.601L113.102 20.493H116.389L117.699 17.4303H124.618L125.853 20.493ZM118.687 14.8904L121.208 8.78979L123.58 14.8904H118.687ZM152.245 14.3426H154.271L159.263 20.4682H163.463L156.792 12.5996L162.623 5.25391H158.893L154.049 11.7779H152.245V5.25391H148.983V20.4682H152.245V14.3426ZM102.328 11.2052V7.81867H110.854V5.27881H99.0664V20.493H105.862C109.668 20.493 111.867 18.7501 111.867 15.7122C111.867 12.7988 109.89 11.2052 106.282 11.2052H102.328ZM102.328 17.9533V13.745H105.738C107.814 13.745 108.778 14.4422 108.778 15.8616C108.778 17.281 107.765 17.9781 105.738 17.9781H102.328V17.9533Z"
					fill="#21A038"
				/>
				<path
					d="M22.5352 5.1543C23.1282 5.92623 23.6225 6.77285 24.0426 7.66927L12.626 16.1603L7.83203 13.1225V9.48702L12.6013 12.5L22.5352 5.1543Z"
					fill="#21A038"
				/>
				<path
					d="M2.96543 12.874C2.96543 12.6997 2.96543 12.5503 2.99014 12.376L0.0989299 12.2266C0.0989299 12.4258 0.0742188 12.6499 0.0742188 12.8491C0.0742188 16.3352 1.48276 19.4975 3.75618 21.7884L5.80721 19.7216C4.05272 17.9785 2.96543 15.5633 2.96543 12.874Z"
					fill="url(#paint0_linear_21889_17616)"
				/>
				<path
					d="M12.6044 3.16142C12.7774 3.16142 12.9257 3.16142 13.0987 3.18632L13.2469 0.272947C13.0492 0.272947 12.8268 0.248047 12.6291 0.248047C9.16957 0.248047 6.03124 1.66738 3.75781 3.95824L5.80884 6.02499C7.53862 4.25705 9.96033 3.16142 12.6044 3.16142Z"
					fill="url(#paint1_linear_21889_17616)"
				/>
				<path
					d="M12.6034 22.5843C12.4305 22.5843 12.2822 22.5843 12.1092 22.5594L11.9609 25.4728C12.1586 25.4728 12.381 25.4976 12.5787 25.4976C16.0382 25.4976 19.1766 24.0783 21.45 21.7875L19.3989 19.7207C17.6692 21.5135 15.2722 22.5843 12.6034 22.5843Z"
					fill="url(#paint2_linear_21889_17616)"
				/>
				<path
					d="M18.038 4.85613L20.4844 3.03838C18.3346 1.29534 15.5916 0.224609 12.6016 0.224609V3.13798C14.6279 3.16288 16.506 3.78539 18.038 4.85613Z"
					fill="url(#paint3_linear_21889_17616)"
				/>
				<path
					d="M25.1571 12.8734C25.1571 12.1015 25.0829 11.3544 24.9594 10.6074L22.2659 12.6244C22.2659 12.6991 22.2659 12.7987 22.2659 12.8734C22.2659 15.7369 21.0302 18.3018 19.0781 20.0697L21.0302 22.236C23.5508 19.9451 25.1571 16.5836 25.1571 12.8734Z"
					fill="#21A038"
				/>
				<path
					d="M12.6039 22.5853C9.76213 22.5853 7.21687 21.3402 5.46238 19.373L3.3125 21.3402C5.61064 23.9049 8.92194 25.4986 12.6039 25.4986V22.5853Z"
					fill="url(#paint4_linear_21889_17616)"
				/>
				<path
					d="M6.15318 5.67809L4.201 3.51172C1.65574 5.82748 0.0742188 9.16417 0.0742188 12.8744H2.96543C2.96543 10.0357 4.201 7.44603 6.15318 5.67809Z"
					fill="url(#paint5_linear_21889_17616)"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_21889_17616"
					x1="3.44767"
					y1="21.4339"
					x2="0.495597"
					y2="12.8353"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.1444" stopColor="#F2E913" />
					<stop offset="0.3037" stopColor="#E7E518" />
					<stop offset="0.5823" stopColor="#CADB26" />
					<stop offset="0.891" stopColor="#A3CD39" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_21889_17616"
					x1="4.58195"
					y1="3.62949"
					x2="12.0764"
					y2="0.75158"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.0592" stopColor="#0FA8E0" />
					<stop offset="0.5385" stopColor="#0099F9" />
					<stop offset="0.9234" stopColor="#0291EB" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_21889_17616"
					x1="11.7912"
					y1="23.0199"
					x2="20.7257"
					y2="20.9853"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.1226" stopColor="#A3CD39" />
					<stop offset="0.2846" stopColor="#86C339" />
					<stop offset="0.8693" stopColor="#21A038" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_21889_17616"
					x1="12.0075"
					y1="2.08021"
					x2="19.436"
					y2="4.38981"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.0566" stopColor="#0291EB" />
					<stop offset="0.79" stopColor="#0C8ACB" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_21889_17616"
					x1="4.04763"
					y1="21.8018"
					x2="12.0266"
					y2="24.8059"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.1324" stopColor="#F2E913" />
					<stop offset="0.2977" stopColor="#EBE716" />
					<stop offset="0.5306" stopColor="#D9E01F" />
					<stop offset="0.8023" stopColor="#BBD62D" />
					<stop offset="0.9829" stopColor="#A3CD39" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_21889_17616"
					x1="2.28953"
					y1="13.2263"
					x2="5.48099"
					y2="4.86046"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.0698" stopColor="#A3CD39" />
					<stop offset="0.2599" stopColor="#81C55F" />
					<stop offset="0.9216" stopColor="#0FA8E0" />
				</linearGradient>
				<clipPath id="clip0_21889_17616">
					<rect width="163.588" height="27" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
